import { getRandomUid } from 'utilities/uuid.service';

function SwitchBox({ labelProps = {}, inputProps = {}, parentProps = {} }) {
  const { label = 'Switch label', ...rest } = labelProps;
  const { id, tabIndex, onKeyDown, onChange, checked, ...props } = inputProps;

  const SwitchID = id ?? getRandomUid();

  const handleWrapperKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      toggleSwitch();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  // Toggle function
  const toggleSwitch = () => {
    if (onChange) {
      onChange({
        target: {
          checked: !checked,
          type: 'checkbox',
        },
      });
    }
  };

  // Handle click on wrapper
  const handleWrapperClick = (e) => {
    e.preventDefault();
    toggleSwitch();
  };

  return (
    <span
      className="checkBlock"
      tabIndex={tabIndex !== undefined ? tabIndex : 0} // Make wrapper focusable
      onKeyDown={handleWrapperKeyDown}
      onClick={handleWrapperClick}
      role="switch"
      aria-checked={checked}
      aria-labelledby={`${SwitchID}-label`}
      {...parentProps}
    >
      <input
        type="checkbox"
        id={SwitchID}
        tabIndex={-1}
        checked={checked}
        onChange={() => {}} // Controlled by wrapper
        readOnly
        {...props}
      />
      <label id={`${SwitchID}-label`} htmlFor={SwitchID} tabIndex={-1} {...rest}>
        {label}
      </label>
    </span>
  );
}

export default SwitchBox;
